import { z } from "zod";
// Reviewer identity is never disclosed on this endpoint — every entry renders
// as "Verified guest" client-side, matching the contract's privacy guarantee.
export const PublicReviewSchema = z.object({
    id: z.union([z.string(), z.number()]),
    rating: z.number(),
    comment: z.string().nullable(),
    createdAt: z.string(),
    providerReply: z.string().nullable().optional(),
});
export const PublicReviewsMetaSchema = z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
});
export const PublicReviewsResultSchema = z.object({
    reviews: z.array(PublicReviewSchema),
    meta: PublicReviewsMetaSchema,
});
